<template>
  <v-card>
    <div class="devConfigHeader">
      <label class="modal-label" >History</label>
    </div>
    <v-layout>
      <v-data-table 
        :headers="devLogHeaders"
        :items="rows"
        item-class="class"
        :sort-by.sync="pagination.key"
        :items-per-page="itemsPerPage"
        hide-default-footer
        style="max-width: 100%;"
        @update:sort-by="updateSort"
        @update:sort-desc="updateSort">
          <template slot="items" slot-scope="props">
            <v-row no-gutters fluid>
              <v-col>{{ props.item.tmStamp }}</v-col>
              <v-col>{{ props.item.username }}</v-col>
              <v-col>{{ props.item.field }}</v-col>
              <v-col>{{ props.item.oldValues }}</v-col>
              <v-col>{{ props.item.newValues }}</v-col>
            </v-row>
          </template>
        </v-data-table>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: "deviceHistoryTable",
  props: {
    rows: Array,
    totalPages: Number,
    pagination: Object
  },
  data() {
    return {
      devLogHeaders: [
        {text: "Date", value:"tmStamp", width: "8%"}, 
        {text: "User", value:"username", width: "8%"}, 
        {text: "Field", value:"field", width: "8%"}, 
        {text: "OldValues", value:"oldValues", width: "38%", class: "jsonValues"},
        {text: "NewValues", value:"newValues", width: "38%", class: "jsonValues"}
      ],
      itemsPerPage: -1
    };
  },
  methods: {
    updateSort(){
      this.$emit("updateSort", this.pagination);
    },
    handleClickPage() {
      this.$emit("pageInfo", this.pagination);
    }
  }
};
</script>


<style lang="scss">
  @media (width >= 1700px) {
    td {
      max-width: 525px !important;
    }
  }

  @media (width >= 2360px) {
    td {
      max-width: 900px !important;
    }
  }

  .jsonValues {
    min-width: 525px !important;
  }
</style>